import React, { useState } from 'react';
import './Sc2Calculator.css';
import { RACES } from './sc2Data';
import UnitLibrary from './UnitLibrary';
import IncomeCalculator from './IncomeCalculator';
import ProductionPlanner from './ProductionPlanner';
import BuildChain from './BuildChain';
import Guide from './Guide';

const TABS = [
  { id: 'library', label: '📚 Библиотека' },
  { id: 'income', label: '⛏️ Добыча' },
  { id: 'production', label: '🏭 Продакшен' },
  { id: 'chain', label: '🔗 Цепочка постройки' },
  { id: 'guide', label: '🎓 Гайд' },
];

function Sc2Calculator() {
  const [raceId, setRaceId] = useState('terran');
  const [tab, setTab] = useState('library');

  // Shared economy state, used by the income tab and the production planner.
  const [econ, setEcon] = useState({
    bases: 2,
    mineralWorkers: 32,
    gasWorkers: 6,
    orbitals: 2, // Terran only (MULE income)
    queens: 2, // Zerg only (inject larvae)
  });

  const race = RACES[raceId];

  return (
    <div className="sc2-calc">
      <div className="sc2-race-bar">
        {Object.values(RACES).map((r) => (
          <button
            key={r.id}
            className={`sc2-race-btn ${raceId === r.id ? 'active' : ''}`}
            style={raceId === r.id ? { borderColor: r.color, color: r.color } : {}}
            onClick={() => setRaceId(r.id)}
          >
            <span className="sc2-race-icon">{r.icon}</span>
            {r.ru}
          </button>
        ))}
      </div>

      <div className="sc2-tab-bar">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`sc2-tab-btn ${tab === t.id ? 'active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="sc2-tab-content" style={{ '--race-color': race.color }}>
        {tab === 'library' && <UnitLibrary raceId={raceId} />}
        {tab === 'income' && <IncomeCalculator raceId={raceId} econ={econ} setEcon={setEcon} />}
        {tab === 'production' && (
          <ProductionPlanner raceId={raceId} econ={econ} setEcon={setEcon} />
        )}
        {tab === 'chain' && <BuildChain raceId={raceId} />}
        {tab === 'guide' && <Guide raceId={raceId} />}
      </div>
    </div>
  );
}

export default Sc2Calculator;
